import React, { useMemo } from "react";
import { Box, Grid, Typography, Slider } from "@mui/material";
import { makeStyles } from "tss-react/mui";
// import { useCourse } from "../../../pages/course/hooks";
// import { useQuiz, useQuizTimer } from "../../../pages/quiz/hooks";
import { addLeadingZero, formatTime } from "../../utils";
import { useCourse } from "../../pages/course/hooks";
import { useQuiz, useQuizTimer } from "../../pages/quiz/hooks";
import cloclImage from "../../assets/images/quiz/clock.svg"

const useStyles = makeStyles()((theme) => ({
    root: {

    },
    title: {
        fontSize: '36px',
        fontWeight: 600,
    },
    subText: {
        fontSize: '18px',
        fontWeight: 400,
    },
    statsContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '100%'
    },
    activeQuestion: {
        fontSize: '20px',
        fontWeight: 600,
        color: 'var(--mui-palette-primary-orange)'
    },
    questionNumber: {
        fontSize: '20px',
        fontWeight: 600,
        color: 'var(--mui-palette-primary-light)',
    },
    sliderRoot: {
        width: '100%', // Adjust as needed
        padding: '15px 0',
    },
    slider: {
        height: 8,
        color: '#e0e7ff', // Background color for the track
        '& .MuiSlider-thumb': {
            height: 34,
            width: 34,
            backgroundColor: '#3b82f6', // Color for the thumb
            border: '8px solid white',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            '&:hover, &.Mui-focusVisible': {
                boxShadow: '0px 0px 0px 8px rgba(59, 130, 246, 0.16)',
            },
            '&.Mui-active': {
                boxShadow: '0px 0px 0px 12px rgba(59, 130, 246, 0.16)',
            },
        },
        '& .MuiSlider-rail': {
            height: 8,
            opacity: 1,
            backgroundColor: '#e0e7ff', // Rail background color
        },
        '& .MuiSlider-track': {
            height: 8,
            borderRadius: 4,
            backgroundColor: '#3b82f6', // Track color #f3f4f6
        },
    },
    clockContainer: {
        display: 'flex',
        alignItems: 'center',
        color: '#fff', // White text color
    },
    clockIcon: {
        width: '25px', // Adjust the size of the clock image
        height: '25px',
        backgroundImage: `url(${cloclImage})`, // Add your clock image path here
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        zIndex: 1
    },
    timeText: {
        fontSize: '1em', // Adjust the size to match the large font
        marginLeft: theme.spacing(-2),
        borderRadius: '14px',
        backgroundColor: '#FF5722',
        padding: theme.spacing(1),
        fontWeight: 'bold',
        lineHeight: 0,
        width: '70px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
        textShadow: '0px 0px 2px rgba(0, 0, 0, 0.25)'
    },
}))

export const DiagnosticHeader = () => {
    const { current, currentChapter, currentSession } = useCourse();
    const { currentQuestionNumber, quizDetails } = useQuiz();
    const { classes } = useStyles();
    const { timer } = useQuizTimer();

    const percent = useMemo(() => Math.round(((currentQuestionNumber ? (currentQuestionNumber + 1) : 0) / (quizDetails?.noOfQuestions || 0)) * 100), [currentQuestionNumber, quizDetails])

    return (
        <Grid sx={{ padding: 1 }} container spacing={2}>
            <Grid item xs={12} md={4}>
                {Object.keys(current).length > 0 && (
                    <Box>
                        <Typography variant="h3" className={classes.title}>
                            {current.courseName}
                        </Typography>
                        <Typography variant="div" className={classes.subText}>
                            {currentSession.name}
                        </Typography>
                    </Box>
                )}
            </Grid>
            <Grid container item sx={12} md={8} justifyContent="space-between" alignItems="center">
                <Grid item xs={8} style={{ paddingTop: 0 }}>
                    <div className={classes.statsContainer}>
                        {/* <Slider
                                className={classes.slider}
                                classes={{ root: classes.sliderRoot }}
                                value={percent}
                                disabled
                            /> */}
                        <Slider
                            sx={{
                                width: '50%',
                                height: 8,
                                color: '#e0e7ff',
                                '& .MuiSlider-rail': {
                                    height: 8,
                                    opacity: 1,
                                    backgroundColor: '#D0DAFF',
                                    border: '5px solid #fff'

                                },
                                '& .MuiSlider-track': {
                                    height: 8,
                                    borderRadius: 4,
                                    backgroundColor: '#4A8EFF',
                                },
                                '& .MuiSlider-thumb': {
                                    height: 34,
                                    width: 34,
                                    borderRadius: '50%',
                                    position: 'relative',
                                    background: '#4A8EFF',
                                    border: '8px solid white',
                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    '&:hover, &.Mui-focusVisible': {
                                        boxShadow: '0px 0px 0px 8px rgba(59, 130, 246, 0.16)',
                                    },
                                    '&.Mui-active': {
                                        boxShadow: '0px 0px 0px 12px rgba(59, 130, 246, 0.16)',
                                    },
                                    '&::before': {
                                        content: '""',
                                        display: 'block',
                                        width: '80%',
                                        height: '80%',
                                        borderRadius: '50%',
                                        background: '#398CE2',
                                        position: 'absolute',
                                        zIndex: -1,
                                    },
                                    '&::after': {
                                        content: '""',
                                        display: 'block',
                                        width: '120%',
                                        height: '120%',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(193.28deg, #B3B3B3 5.42%, #B6B6B6 40%, #C2C2C2 79%, #CCCCCC 99%)',
                                        position: 'absolute',
                                        // top: '15px',
                                        // left: '15px',
                                        border: '2px solid #aaa7a7',
                                        opacity: 0.3,
                                        zIndex: -2,
                                    },
                                },
                            }}
                            value={percent}
                            disabled
                        />
                        <Box sx={{ ml: 4 }}>
                            <span className={classes.activeQuestion}>{addLeadingZero(currentQuestionNumber + 1)}</span>
                            <span className={classes.questionNumber}>/{addLeadingZero(quizDetails.noOfQuestions)}</span>
                        </Box>
                    </div>
                </Grid>
                <Box className={classes.clockContainer}>
                    <Box className={classes.clockIcon} />
                    <Typography className={classes.timeText}>{formatTime(timer)}</Typography>
                </Box>
            </Grid>
        </Grid>
    )
}